import React, { createContext, useContext, useState } from 'react';

const AdminContext = createContext();
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(() => {
    try { const s = localStorage.getItem('dhs-admin'); return s ? JSON.parse(s) : null; } catch { return null; }
  });

  const _persist = (token, email, name) => {
    const a = { email, name, role: 'admin', token };
    localStorage.setItem('dhs-admin', JSON.stringify(a));
    setAdmin(a);
  };

  const startLogin = async (email, password) => {
    try {
      const res = await fetch(`${BACKEND}/api/auth/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase(), password }),
      });
      const j = await res.json();
      if (!res.ok) return { ok: false, error: j.detail || 'Sign in failed' };
      return { ok: true, otpRequired: true };
    } catch (e) {
      return { ok: false, error: 'Network error, please try again.' };
    }
  };

  const verifyOtp = async (email, code) => {
    try {
      const res = await fetch(`${BACKEND}/api/auth/otp/verify`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase(), code: code.trim(), purpose: 'login' }),
      });
      const j = await res.json();
      if (!res.ok) return { ok: false, error: j.detail || 'Incorrect or expired code' };
      _persist(j.token, email, j.name);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: 'Network error, please try again.' };
    }
  };

  const startSetup = async (email) => {
    try {
      const res = await fetch(`${BACKEND}/api/auth/otp/send`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase(), purpose: 'setup' }),
      });
      const j = await res.json();
      if (!res.ok) return { ok: false, error: j.detail || 'Could not send code' };
      return { ok: true };
    } catch { return { ok: false, error: 'Network error' }; }
  };

  const verifySetupOtp = async (email, code) => {
    try {
      const res = await fetch(`${BACKEND}/api/auth/otp/verify`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase(), code: code.trim(), purpose: 'setup' }),
      });
      const j = await res.json();
      if (!res.ok) return { ok: false, error: j.detail || 'Incorrect or expired code' };
      return { ok: true, resetToken: j.reset_token };
    } catch { return { ok: false, error: 'Network error' }; }
  };

  const setPassword = async (resetToken, newPassword) => {
    try {
      const res = await fetch(`${BACKEND}/api/auth/password/set`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reset_token: resetToken, new_password: newPassword }),
      });
      const j = await res.json();
      if (!res.ok) return { ok: false, error: j.detail || 'Could not set password' };
      _persist(j.token, admin?.email || j.email || '', j.name);
      return { ok: true };
    } catch { return { ok: false, error: 'Network error' }; }
  };

  const logout = () => { localStorage.removeItem('dhs-admin'); setAdmin(null); };

  return (
    <AdminContext.Provider value={{ admin, startLogin, verifyOtp, startSetup, verifySetupOtp, setPassword, logout }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
